import { Flex } from 'foundations-components/components/Flex';
import { Header } from 'foundations-components/transitional/components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MainContentLayout = ({
  children,
  title
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: 1,
    flexDirection: "column",
    children: [title !== undefined && /*#__PURE__*/_jsx(Header, {
      title: title,
      paddingBlockEnd: "300"
    }), /*#__PURE__*/_jsx(Flex, {
      paddingInline: "1100",
      paddingBlock: "500",
      flexGrow: 1,
      flexDirection: "column",
      children: children
    })]
  });
};